import { render, staticRenderFns } from "./MenuArrow.vue?vue&type=template&id=ce39ae80&"
import script from "./MenuArrow.vue?vue&type=script&lang=ts&"
export * from "./MenuArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports